import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=b7fcd5da&scoped=true&"
import script from "./Split.vue?vue&type=script&lang=ts&"
export * from "./Split.vue?vue&type=script&lang=ts&"
import style0 from "./Split.vue?vue&type=style&index=0&id=b7fcd5da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fcd5da",
  null
  
)

export default component.exports